import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { DEAL_SECTION_KEYS } from "../deal.constants";

import { rows } from "./section-deal-organization-rows";

export class DealOrganization extends Component {
  render() {
    const { data, dealId, isSold, history, ...other } = this.props;
    //   if (!data) return null;

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Organization",
            key: DEAL_SECTION_KEYS.GENERAL_INFORMATION,
            isExpandable: true,
            isTitleGroup: false,
            buttonLabel: "Edit Details",
            showEditButton: true,
            onClick: () => history.push(`/deal/${dealId}/edit/${DEAL_SECTION_KEYS.ORGANIZATION}`),
            sections: [
              <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />
            ]
          }
        ]}
      />
    );
  }
}
